import { CatalogSelectableOption } from 'app/ecommerce/common/components/catalog'
import styled from 'styled-components'
import React from 'react'
import { useIntl } from 'react-intl'
import { H8 } from 'app-v2/design-systems'
import { SPACING } from 'app-v2/design-tokens'
import { ingredientType } from 'shared/utils'

type CatalogUniqueChoiceProps = {
    ingredients: Array<any>,
    title?: string,
    groupName: string,
    onSelected: (id: string, groupTitle: string) => void,
    selectedIdIngredient: string
}

export const CatalogUniqueChoice = ({
    ingredients,
    title,
    groupName,
    onSelected,
    selectedIdIngredient
}: CatalogUniqueChoiceProps) => {
    const intl = useIntl()

    return (
        <Container>
            <H8>
                {title && title !== ingredientType.NONE
                    ? intl.formatMessage({
                          id: `clickandcollect.catalog.product.personalize.category.${title}`
                      })
                    : intl.formatMessage({
                          id:
                              'clickandcollect.catalog.product.personalize.uniqueChoice'
                      })}
            </H8>
            <div>
                {ingredients &&
                    ingredients.map(({ id, name, price, image }) => (
                        <CatalogSelectableOption
                            id={id}
                            name={name}
                            key={id}
                            isSelected={id === selectedIdIngredient}
                            onOptionSelected={() => {
                                onSelected(id, groupName)
                            }}
                            imageUrl={image}
                            price={price}
                        />
                    ))}
            </div>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: ${SPACING.M};
    width: 100%;
    gap: ${SPACING.XS};
`
